import type {CustomScroolbarProps} from "@/styles/customScroolbar.types";

import {css} from "styled-components";

export const customScroolbar = ({customScroolbar = false}: CustomScroolbarProps) => {
    return customScroolbar && css`
      &::-webkit-scrollbar {
        width: 4px;
        height: 4px;
      }

      &::-webkit-scrollbar-track {
        border-radius: 2px;
        background-color: #ebebeb;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #afafaf;
        border-radius: 2px;
      }
    `;
};
